import { initializeApp } from "firebase/app"
import { getDatabase } from "firebase/database"
import firebaseConfig from "keys/firebase.json"

const firebaseApp = initializeApp(firebaseConfig)
export const realtimeDatabase = getDatabase(firebaseApp)
